export default __webpack_public_path__ + "static/media/Hero_Descent.7583a9d9.gif";